import React, { useState } from "react";
import { Typography, Button, Tooltip } from "@bca/ui-library";

interface CopyLabelWithTooltipProps {
  infoToCopy?: string;
  labelCopied: "VRM" | "Lot Number";
  children: React.ReactNode;
}

const CopyLabelWithTooltip: React.FunctionComponent<
  CopyLabelWithTooltipProps
> = ({ children, infoToCopy, labelCopied }) => {
  const [copyIconStatus, setCopyIconStatus] = useState(null);

  const copyToClipboard = (valueToCopy: string) => {
    setCopyIconStatus("clicked");

    return navigator.clipboard.writeText(valueToCopy);
  };

  const onMouseEnterHandler = () => {
    setCopyIconStatus("hovered");
  };
  const onMouseLeaveHandler = () => {
    setCopyIconStatus("hovered");
  };
  const onClickHandler = () => copyToClipboard(infoToCopy);

  return (
    <Button
      height={22}
      variant="tertiary"
      padding={0}
      css={`
        border-radius: 0;
        text-decoration: none;
      `}
      onMouseEnter={onMouseEnterHandler}
      onMouseLeave={onMouseLeaveHandler}
      onClick={onClickHandler}
    >
      <Tooltip
        id="tooltip-for-uk-bank-values"
        tooltipLeftOffset={1}
        arrowLeftOffset={-2}
        tooltipTopOffset={2}
        customTrigger={<>{children}</>}
        placement="bottom"
        zIndex={1000}
      >
        <Typography variant="body" color="#64798C" m={0}>
          {copyIconStatus === "hovered" && "Copy"}
          {copyIconStatus === "clicked" && `${labelCopied} Copied!`}
        </Typography>
      </Tooltip>
    </Button>
  );
};

export default CopyLabelWithTooltip;
